var map = {
	"./menu-anydb.avif": 2967,
	"./menu-c-flow.avif": 3705,
	"./menu-customized-software.avif": 9778,
	"./menu-environment-monitoring-system.avif": 5059,
	"./menu-erp-solutions.avif": 931,
	"./menu-file-cloud.avif": 7547,
	"./menu-it-network-monitoring.avif": 7420,
	"./menu-it-solutions.avif": 3369,
	"./menu-ivisita.avif": 5862,
	"./menu-meeting-room.avif": 6542,
	"./menu-mobile-application-development.avif": 3804,
	"./menu-paperless-meeting.avif": 7848,
	"./menu-web-application-development.avif": 822,
	"./menu-weeds.avif": 1713,
	"./png/menu-anydb.png": 1917,
	"./png/menu-c-flow.png": 2045,
	"./png/menu-customized-software.png": 4730,
	"./png/menu-customized-software1.png": 5945,
	"./png/menu-environment-monitoring-system.png": 7645,
	"./png/menu-erp-solutions.png": 9313,
	"./png/menu-file-cloud.png": 1775,
	"./png/menu-it-network-monitoring.png": 1432,
	"./png/menu-it-solutions.png": 129,
	"./png/menu-ivisita.png": 790,
	"./png/menu-meeting-room.png": 4992,
	"./png/menu-mobile-application-development.png": 8534,
	"./png/menu-paperless-meeting.png": 8268,
	"./png/menu-web-application-development.png": 8614,
	"./png/menu-weeds.png": 99,
	"./png/programming-background-with-person-working-with-codes-computer.jpg": 7542,
	"./programming-background-with-person-working-with-codes-computer.avif": 166
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4123;